import { Row, Col, Container, Card, Button, Table, Badge, Dropdown, Form, Spinner } from "react-bootstrap";
import Layout from "../../components/Layout";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import Paginator from "../../components/table/Paginator";
import { useEffect, useRef, useState } from "react";
import DrewsModal from "../../components/modal/DrewsModal";
import { useDispatch, useSelector } from "react-redux";
import { createNewTicket, getAllTickets, manageTicket } from "../../redux/slices/support.slice";
import Swal from "sweetalert2";
import { useNavigate } from "react-router-dom";
import dateFormatter from "../../utils/dateFormatter";
import formatCurrency from "../../utils/currencyFormmter";


const Tickets = () => {

    const dispatch = useDispatch()
    const isLoaded = useRef(false)

    const { message } = useSelector((state) => state.message)

    const navigate = useNavigate()

    const initialState = {
        errors: {},
        payload: {},
        loading: false,
        tickets: [],
        transaction: {},
        attachment: null,
        file_name: '',
        showForm: false,
        modalShow: false,
        analytics: {},
        paginationData: {},
    }

    const [state, setState] = useState(initialState)

    useEffect(() => {
        if(!isLoaded.current) {
            loadTickets()
            isLoaded.current = true
        }
    }, [])


    const handleInput = (event) => {
        const { name, value } = event.target;
        if(name === 'save_beneficiary') {
            let val = event.target.checked ? 'yes' : 'no'
            setState((prevState) => ({...prevState, payload:{...prevState.payload, [name]: val}}))
        }
        else {
            setState((prevState) => ({...prevState, payload:{...prevState.payload, [name]: value}}))
        }
    }

    const handleValidation = (event) => {

        const { name, value } = event.target

        const regex = /^\d*\.?\d*$/;

        if(value === '' && event.target.attributes.required) {
            event.target.style = "border: 1px solid red"
            setState((prevState) => ({ ...prevState, errors: { ...prevState.errors, [name]: `${name[0].toUpperCase() + name.split('_').join(' ').slice(1)} is required` }}))
        }
        else if (name ==='amount' && !regex.test(value)) {
            event.target.style = "border: 1px solid red"
            setState((prevState) => ({ ...prevState, errors: {...prevState.errors, [name]: `${name[0].toUpperCase() + name.split('_').join(' ').slice(1)} is required` }}))
        }
        else {
            event.target.style = "border-style: transparent"
            delete state.errors[name]
            setState((prevState) => ({ ...prevState, errors: {...prevState.errors}}))
        }
    }

    const selectTransaction = (id) => {
        navigate(`/tickets/${id}`)
    }

    const loadTickets = () => {
        dispatch(getAllTickets())
        .then((response) => {
            let analytcics = {}
            let results  = []
            let pagination = {}

            if(response.payload?.results) {
                results = response.payload?.results
            }
            if(response.payload?.analytics) {
                analytcics = response.payload?.analytcics
            }
            if(response.payload?.next || response.payload?.previous) {
                pagination = {
                    next: response.payload?.next,
                    prev: response.payload?.previous,
                }
            }
            setState((prevState) => ({...prevState, tickets: results, analytics: analytcics, paginationData: pagination}))
        })
    }

    const submitTicket = () => {
        let formdata = new FormData()
        formdata.append('attachment', state.attachment)
        formdata.append('desk', state.payload.department)
        formdata.append('message', state.payload.message)
        formdata.append('subject', state.payload.subject)
        dispatch(createNewTicket(formdata))
        .then((response) => {
            if(response.payload?.success) {
                Swal.fire({
                    icon: 'success',
                    text: response.payload?.message
                }).then(() => setState((prevState) => ({...prevState, showForm: false})))
            }
            else if(response.payload?.message) {
                Swal.fire({
                    icon: 'error',
                    text: response.payload?.message
                })
            }
            loadTickets()
        })
    }

    const handleFileSelect = (event) => {
        const file = event.target.files[0];
        const reader = new FileReader();
        reader.readAsDataURL(file);
        reader.onload = (e) => {
            setState((prevState) => ({...prevState, attachment: file, file_name: reader.result}))
        };
    }

    const resolveTicket = (id) => {
        dispatch(manageTicket(id))
        .then((res) => {
            if(res.payload?.success) {
                Swal.fire({
                    icon: "success",
                    text: res.payload?.message,
                })
            } else {
                Swal.fire({
                    icon: "error",
                    text: res.payload?.message,
                });
            }
            loadTickets()
        })
    }

    const handlePagination = (data) => {
        setState((prevState) => ({...prevState, payload: {...prevState.payload, page: data}}))
    }

    return (
        <Layout>
            <Container className="mt-4 px-4 mb-4">
                <Col md={12} lg={11} sm={12}  className="d-flex align-items-center justify-content-between">
                    <h3>All Tickets</h3>
                    <Button 
                        type="button" 
                        variant="primary" 
                        size="lg"
                        onClick={ () => setState((prevState) => ({...prevState, showForm: true}))}
                    >
                        <FontAwesomeIcon icon="plus" /> <span>Create new Tickets</span>
                    </Button>
                </Col>

                <div className="mt-4">
                    <Row className="data-card mb-4">
                        <Col md={4} className="mb-2">
                            <Card className="border-0 shadow-sm bg--light">
                                <Card.Body className="d-flex align-items-center gap-3 p-3">
                                    <div className="icon">
                                        <i className="lni lni-ticket" style={{fontSize: "20px"}}></i>
                                    </div>
                                    <div>
                                        <h5 className="m-0">{formatCurrency(state.analytics?.overall_total).formatted}</h5>
                                        <p className="m-0">Total Number of Tickets created</p>
                                    </div>
                                </Card.Body>
                            </Card>
                        </Col>
                        <Col md={4} className="mb-2">
                            <Card className="border-0 shadow-sm bg--success">
                                <Card.Body className="d-flex align-items-center gap-3 p-3">
                                    <div className="icon">
                                        <i className="lni lni-ticket" style={{fontSize: "20px"}}></i>
                                    </div>
                                    <div>
                                        <h5 className="m-0">{formatCurrency(state.analytics?.total_resolved).formatted}</h5>
                                        <p className="m-0">Resolved Tickets</p>
                                    </div>
                                </Card.Body>
                            </Card>
                        </Col>
                        <Col md={4} className="mb-2">
                            <Card className="border-0 shadow-sm bg--warning">
                                <Card.Body className="d-flex align-items-center gap-3 p-3">
                                    <div className="icon">
                                        <i className="lni lni-ticket" style={{fontSize: "20px"}}></i>
                                    </div>
                                    <div>
                                        <h5 className="m-0">{formatCurrency(state.analytics?.total_in_progress).formatted}</h5>
                                        <p className="m-0">In Progress</p>
                                    </div>
                                </Card.Body>
                            </Card>
                        </Col>
                    </Row>

                    <Card className="border-0 shadow-sm mb-3">
                        <Card.Body className="table-responsive-lg table-responsive">
                            <Table size="sm" className="table-color">
                                <thead>
                                    <tr>
                                        <th>Ticket ID</th>
                                        <th>Subject</th>
                                        <th>Handled by</th>
                                        <th>Date Created</th>
                                        <th>Status</th>
                                    </tr>
                                </thead>
                                <tbody>
                                    {
                                        state.tickets?.length ? (
                                            state.tickets?.map((item, index) => (
                                                <tr key={index}>
                                                    <td>
                                                        #{item.ticketID}
                                                    </td>
                                                    <td>
                                                        <div className="m-0 d-flex gap-2 align-items-center">
                                                            <strong className="text-dark">
                                                                <svg xmlns="http://www.w3.org/2000/svg" width="20" height="20" viewBox="0 0 20 20" fill="none">
                                                                    <path d="M10 0L20 10L10 20L0 10L10 0Z" fill="#EB5757"/>
                                                                </svg>
                                                                Complaint,
                                                            </strong>
                                                            <span>
                                                                {item.subject}
                                                            </span>
                                                        </div>
                                                    </td>
                                                    <td>
                                                        {item.desk || 'Nil'}
                                                    </td>
                                                    <td>
                                                        {dateFormatter(item.date)}
                                                    </td>
                                                    <td>
                                                        <div className="d-flex m-0 align-items-center justify-content-between">
                                                            <Badge 
                                                                className={item?.status.toLowerCase() === 'success' ? 'badge-active' : 
                                                                (item?.status.toLowerCase() === 'failed' ? 'badge-failed' : 
                                                                (item?.status.toLowerCase() === 'resolved' ? 'badge-used' : 'badge-pending'))}
                                                            >
                                                                <svg xmlns="http://www.w3.org/2000/svg" width="10" height="10" viewBox="0 0 10 10" fill="none">
                                                                    <circle cx="5" cy="5" r="5" fill={
                                                                        item.status.toLowerCase() === 'success' ? "#008000" : 
                                                                        (item.status.toLowerCase() === 'failed' ? "#EB5757" : 
                                                                        (item.status.toLowerCase() === 'resolved' ? "#828282" : "#FAB941"))
                                                                    }
                                                                    />
                                                                </svg>
                                                                <span className="ps-1">
                                                                    {item.status}
                                                                </span>
                                                            </Badge> 
                                                            <Dropdown>
                                                                <Dropdown.Toggle variant="light" className="border-0 bg-white" size="sm" id="dropdown-basic">
                                                                    <FontAwesomeIcon icon="ellipsis-vertical" style={{fontSize: "20px"}} className="text-muted"/>
                                                                </Dropdown.Toggle>
    
                                                                <Dropdown.Menu className="border-0 shadow px-3 py-4">
                                                                    <Dropdown.Item 
                                                                        eventKey={1} 
                                                                        className="text-primary d-flex align-items-center gap-1" 
                                                                        onClick={() => selectTransaction(item.ticketID)}
                                                                    >
                                                                    <i className="lni lni-eye" style={{fontSize: "20px"}}></i>  View Ticket
                                                                    </Dropdown.Item>
                                                                    <Dropdown.Divider />
                                                                    <Dropdown.Item 
                                                                        eventKey={2} 
                                                                        className="d-flex align-items-center gap-1"
                                                                        onClick={ () => resolveTicket(item.ticketID) }
                                                                    >
                                                                        <FontAwesomeIcon icon="folder-open" /> Mark as resolved
                                                                    </Dropdown.Item>
                                                                </Dropdown.Menu>
                                                            </Dropdown>
                                                        </div>
                                                    </td>
                                                </tr>
                                            ))
                                        )
                                        : (
                                            <tr>
                                                <td colSpan={5} className="text-center text-muted mt-4">No data available</td>
                                            </tr>
                                        )
                                    }
                                </tbody>
                            </Table>
                        </Card.Body>
                    </Card>
                    {
                        state.tickets?.length ? (
                            <div className="table-responsive mt-2">
                                <Paginator
                                    next={state.paginationData.next} 
                                    prev={state.paginationData.prev}
                                    setCurrentPage={ handlePagination }
                                />
                            </div>
                        ) : null
                    }
                </div>
                <DrewsModal
                    show={state.modalShow}
                    onHide={() => setState((prevState) => ({...prevState, modalShow: false}))}
                    size="lg"
                    dismissable={true}
                    title={state.transaction.reference}
                    badge_text={state.transaction.type}
                >
                    <Row>
                        <Col md={6}>
                            <div className="modal-profile">
                                <ul>
                                    <li>
                                        <div>
                                            <p className="pt-2">
                                                <small className="text-muted">Transaction ID</small>
                                                {state.transaction.reference} 
                                            </p>
                                        </div>
                                    </li>
                                    <li>
                                        <div>
                                            <p className="pt-2">
                                                <small className="text-muted">Beneficiary Name</small>
                                                {state.transaction.name} 
                                            </p>
                                        </div>
                                    </li>
                                    <li>
                                        <div>
                                            <p className="pt-2">
                                                <small className="text-muted">Beneficiary Account</small>
                                                {state.transaction.balance}
                                            </p>
                                        </div>
                                    </li>
                                    <li>
                                        <div>
                                            <p className="pt-2">
                                                <small className="text-muted">Status</small>
                                                <span 
                                                className={state.transaction.status === 'success' ? 'text-success' : 
                                                (state.transaction.status === 'failed' ? 'text-danger' : 
                                                (state.transaction.status === 'used' ? 'text-dark' : 'text-warning'))}
                                                >
                                                    {state.transaction.status}
                                                </span> 
                                            </p>
                                        </div>
                                    </li>
                                </ul>

                            </div>
                        </Col>
                        <Col md={6} className="modal-profile">
                            <ul>
                                <li>
                                    <div>
                                        <p className="pt-2">
                                            <small className="text-muted">Amount</small>
                                            {state.transaction.amount}
                                        </p>
                                    </div>
                                </li>
                                <li>
                                    <div>
                                        <p className="pt-2">
                                            <small className="text-muted">Transaction Date</small>
                                            {state.transaction.date}
                                        </p>
                                    </div>
                                </li>
                            </ul>
                        </Col>
                    </Row>
                </DrewsModal>
                <DrewsModal
                    show={state.showForm}
                    onHide={() => setState((prevState) => ({...prevState, showForm: false}))}
                    size="md"
                    dismissable={true}
                    title="Create a Ticket"
                >
                    <Form>
                        <Row>
                            <Form.Group as={Col} md={12} className="mb-3">
                                <Form.Label>Ticket Desk</Form.Label>
                                <Form.Select 
                                    name="department"
                                    required
                                    onChange={handleInput}
                                    onKeyUp={handleValidation}
                                >
                                    <option value="">---Select an option---</option>
                                    <option value="help desk">Helpdesk</option>
                                    <option value="sales">Sales</option>
                                    <option value="support">Support</option>
                                    <option value="IT">IT</option>
                                </Form.Select>
                                {
                                    state.errors['department'] ? 
                                    <Form.Text className="text-danger">{state.errors['department']}</Form.Text> : null
                                }
                            </Form.Group>
                            <Form.Group as={Col} md={12} className="mb-3">
                                <Form.Label>Subject</Form.Label>
                                <Form.Control
                                    type="text"
                                    required
                                    placeholder="Subject"
                                    name="subject"
                                    onChange={handleInput}
                                    onKeyUp={handleValidation}
                                />
                                {
                                    state.errors['subject'] ? 
                                    <Form.Text className="text-danger">{state.errors['subject']}</Form.Text> : null
                                }
                            </Form.Group>
                            <Form.Group as={Col} md={12} className="mb-3">
                                <Form.Label>Message</Form.Label>
                                <textarea 
                                    name="message" 
                                    className="form-control" 
                                    placeholder="Message"
                                    required
                                    onChange={handleInput}
                                    onKeyUp={handleValidation}
                                ></textarea>
                                {
                                    state.errors['message'] ? 
                                    <Form.Text className="text-danger">{state.errors['message']}</Form.Text> : null
                                }
                            </Form.Group>
                            <Form.Group as={Col} md={12} className="mb-3">
                                <Form.Label className="mb-0 text-sm">Attachment</Form.Label>
                                <label htmlFor="attachment" className="custom-file-select form-control form-control-lg p-3">
                                    <FontAwesomeIcon icon="fa fa-arrow-up-from-bracket" /> Upload Attachment
                                    <input
                                        type="file"
                                        name="attachment"
                                        accept="image/*"
                                        size="lg"
                                        id="attachment"
                                        onChange={handleFileSelect}
                                    />
                                </label>
                                {
                                    state.file_name !== null ? (
                                        <img src={state.file_name || 'https://placehold.co/100'} alt="attachment" className="mt-2" width={100} />
                                    ) : null
                                }
                            </Form.Group>
                            <Form.Group 
                                as={Col} 
                                md={12} 
                                className="mt-4 d-grid"
                            >
                                <Button 
                                    variant="primary" 
                                    size="lg"
                                    onClick={submitTicket}
                                    disabled={Object.keys(state.errors).length > 0}
                                >
                                    Send Ticket <Spinner animation={ state.loading ? "border" : null} role="status" size="sm"></Spinner>
                                </Button>
                            </Form.Group>
                        </Row>
                    </Form>
                </DrewsModal>
            </Container>
        </Layout>
    );
}

export default Tickets;